import { lazy } from 'react';
import { Route, Navigate } from 'react-router-dom';
import Loadable from '../../components/loadable/Loadable';
import Settings from '../../view/dashboard/user-dashboard/settings/Settings';
import MyEvents from '../../view/dashboard/user-dashboard/my-events/MyEvents';
import EventBookings from '../../view/dashboard/user-dashboard/my-bookings/event-bookings/EventBookings';
import DemoComponent from '../../components/demo-component/DemoComponent';
import ProtectedRoute from '../ProtectedRoute';

const UserDashboard = Loadable(lazy(() => import('../../view/dashboard/UserDashboard')));
const UserDashboardLayout = Loadable(lazy(() => import('./layout')));

const userDashboardRoutes = (
    <Route element={<ProtectedRoute />}>
        <Route element={<UserDashboardLayout />}>
            <Route path="/user" element={<UserDashboard />}>
                {/* Redirect from /user to /user/dashboard */}
                <Route index element={<Navigate to="/user/dashboard" replace />} />

                <Route path="dashboard" element={<DemoComponent message="User Dashboard" feature="Dashboard Overview" />} />

                <Route path="event-bookings" element={<EventBookings />} />

                <Route path="my-events" element={<MyEvents />} />

                <Route path="event-reports" element={<DemoComponent message="Event Reports" feature="Reports Overview" />} />

                <Route path="help-and-support" element={<DemoComponent message="Help and Support" feature="Support Center" />} />

                <Route path="settings" element={<Settings />} />
            </Route>
        </Route>
    </Route>
);

export default userDashboardRoutes;